// Sticky header without jumps or threshold thrash.
// Only active when header carries [data-sticky-header] (gated in header.php).
//
// The natural (non-sticky) height is measured once and re-measured on resize —
// never while stuck, because the stuck header shrinks and a moving measurement
// makes the thresholds drift (the old glitch). The spacer takes over the full
// natural height the instant the header goes fixed, so the swap is net-zero for
// layout: nothing below the header moves at stick or unstick.
const header = document.querySelector('[data-sticky-header]');

if (header) {
  const spacer = document.createElement('div');
  spacer.className = 'site-header-spacer';
  spacer.setAttribute('aria-hidden', 'true');
  header.after(spacer);

  let naturalHeight = 0;
  let stuck = false;
  let ticking = false;

  const measure = () => {
    if (!stuck) naturalHeight = header.offsetHeight;
  };

  const apply = () => {
    ticking = false;
    const y = window.pageYOffset;
    // Hysteresis: stick once the whole header has scrolled away, unstick only
    // well above that so the two can't rapid-toggle at one boundary.
    const enter = naturalHeight;
    const exit = Math.max(24, naturalHeight * 0.5);

    if (!stuck && y > enter) {
      stuck = true;
      spacer.style.height = `${naturalHeight}px`;
      header.classList.add('is-sticky');
    } else if (stuck && y < exit) {
      stuck = false;
      header.classList.remove('is-sticky');
      spacer.style.height = '0px';
    }
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(apply);
    }
  };

  measure();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    measure();
    onScroll();
  });
  // Re-measure once everything (fonts, promo bar) has settled.
  window.addEventListener('load', measure);
  apply();
}
